import React from 'react';
import './Donation.css';

function Donation() {
  return (
    <div className="donation-container">
      <h1 className="donation-title">Donation</h1>
      <p className="under-construction-text">Under Construction</p>
    </div>
  );
}

export default Donation;
